module.exports = __webpack_public_path__ + "static/metalang-elem-de1a3cfe9a327fb780c6f084f9c9e971.png";